import React from 'react';
import { Form, Field } from 'react-final-form';
import { Row, Col, Button, Label } from 'reactstrap';

const required = (value) => (value ? undefined : 'Required');

const PracticeLocationForm = ({ onSubmit, initialValues, onCancel }) => {
    return (
        <Form
            initialValues={initialValues || {}}
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, pristine }) => (
                <form onSubmit={handleSubmit}>
                    <Row className="mx-2 text-light">
                        <Col sm="12" md="6" className="px-2 py-1">
                            <Label htmlFor="practiceLocation-locationId">Location ID</Label>
                            <Field
                                id="practiceLocation-locationId"
                                name="locationId"
                                component="input"
                                type="text"
                                className="w-100 rounded p-2"
                                placeholder="Location ID"
                                validate={required}
                                disabled={!!initialValues}
                            />
                        </Col>
                        <Col sm="12" md="6" className="px-2 py-1">
                            <Label htmlFor="practiceLocation-name">Name</Label>
                            <Field
                                id="practiceLocation-name"
                                name="name"
                                component="input"
                                type="text"
                                className="w-100 rounded p-2"
                                placeholder="Name"
                                validate={required}
                            />
                        </Col>
                        <Col sm="12" md="6" className="px-2 py-1">
                            <Label htmlFor="practiceLocation-address">Address</Label>
                            <Field
                                id="practiceLocation-address"
                                name="address"
                                component="input"
                                type="text"
                                className="w-100 rounded p-2"
                                placeholder="Address"
                            />
                        </Col>
                        <Col sm="12" md="6" className="px-2 py-1">
                            <Label htmlFor="practiceLocation-city">City</Label>
                            <Field
                                id="practiceLocation-city"
                                name="city"
                                component="input"
                                type="text"
                                className="w-100 rounded p-2"
                                placeholder="City"
                            />
                        </Col>
                        <Col sm="12" md="6" className="px-2 py-1">
                            <Label htmlFor="practiceLocation-stateProvince">State/Province</Label>
                            <Field
                                id="practiceLocation-stateProvince"
                                name="stateProvince"
                                component="input"
                                type="text"
                                className="w-100 rounded p-2"
                                placeholder="State/Province"
                            />
                        </Col>
                        <Col sm="12" md="6" className="px-2 py-1">
                            <Label htmlFor="practiceLocation-postalCode">Postal Code</Label>
                            <Field
                                id="practiceLocation-postalCode"
                                name="postalCode"
                                component="input"
                                type="text"
                                className="w-100 rounded p-2"
                                placeholder="Postal Code"
                            />
                        </Col>
                    </Row>
                    <Row className="mx-2 mt-3">
                        <Col className="d-flex justify-content-end">
                            <Button
                                color="secondary"
                                className="mr-2"
                                onClick={onCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                color="primary"
                                disabled={submitting || pristine}
                            >
                                Save
                            </Button>
                        </Col>
                    </Row>
                </form>
            )}
        />
    );
};

export default PracticeLocationForm;
